import { Arrange, Skeleton } from "@aviary";

const SkeletonShop = () => {
  return (
    <Arrange isVertical>
      {[...Array(3)].map((_, index) => {
        return <Skeleton key={index} type="typography" isFullWidth />;
      })}
    </Arrange>
  );
};

export { SkeletonShop };
